import { Box, Link, Stack, Typography } from "@mui/material";
import { Avatar } from "../../../../components";
import { useBreakpoints } from "../../../../hooks";
import { useUserPageLayoutContext } from "../UserPageLayout";

const UserTitle = () => {
  const { user } = useUserPageLayoutContext();
  const { isMdUp } = useBreakpoints();

  return (
    <Stack direction="row" spacing={{ xs: 0.5, md: 1 }} sx={{ alignItems: { xs: "center", md: "flex-start" } }}>
      <Avatar user={user} border size={isMdUp ? "large" : "small"} />
      <Stack>
        <Typography variant="h3">{user.displayName}</Typography>
        <Box sx={{ mb: 0.5 }}>
          {user.enabled ? (
            user.email !== undefined && (
              <Link href={`mailto:${user.email?.toLowerCase()}`} sx={{ textTransform: "lowercase" }}>
                {user.email}
              </Link>
            )
          ) : (
            <Typography>Deactivated</Typography>
          )}
        </Box>
      </Stack>
    </Stack>
  );
};

export { UserTitle };
